import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { PortfolioCard } from "../widget/PortfolioCard";
import "../css/portfolio.css";

import { IMAGES } from "../constants/image";

const projectData = [
  {
    key: "zeneCommerce",
    title: "ZeneCommerce",
    image: IMAGES.Ecom1Image,
    type: "Web App",
  },
  {
    key: "safaricomMiniApp",
    title: "Safaricom Mini App",
    image: IMAGES.SafariMobile1Image,
    type: "Web App",
  },
  {
    key: "safaricomPwa",
    title: "Safaricom PWA Mobile Experience",
    image: IMAGES.SafariPwa1Image,
    type: "Mobile App",
  },
  {
    key: "safaricomTelegramBot",
    title: "Safaricom Telegram Bot",
    image: IMAGES.SafariBotImage,
    type: "Web App",
  },
  {
    key: "safaricomInternalPlatform",
    title: "Internal Business Platform",
    image: IMAGES.SafariPortal1Image,
    type: "Web App",
  },
  {
    key: "mobileBankingApp",
    title: "ABa Mobile Banking App",
    image: IMAGES.MobileStartImage,
    type: "Mobile App",
  },
  {
    key: "merchantApp",
    title: "ABA Merchant App",
    image: IMAGES.MerchantIntroImage,
    type: "Mobile App",
  },
  {
    key: "shareManagementApp",
    title: "ABa Share App",
    image: IMAGES.ShareFirstImage,
    type: "Mobile App",
  },
  {
    key: "erpSystem",
    title: "ABa ERP System",
    image: IMAGES.ERPImage,
    type: "Web App",
  },
];

export const Portfolio = () => {
  const [filter, setFilter] = useState("All");
  const [activeMenu, setActiveMenu] = useState("All");

  const filteredProjects =
    filter === "All"
      ? projectData
      : projectData.filter((project) => project.type === filter);

  const handleMenuClick = (menu) => {
    setFilter(menu);
    setActiveMenu(menu);
  };

  return (
    <motion.section
      className="portfolio-main"
      id="portfolio"
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      transition={{ duration: 0.8 }}
      viewport={{ once: true }}
    >
      <motion.div
        className="section-header portfolio-header"
        initial={{ y: -20, opacity: 0 }}
        whileInView={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.6 }}
        viewport={{ once: true }}
      >
        <span className="section-tag">Recent Project Portfolio</span>
        <h2>Selected Projects</h2>
      </motion.div>

      <motion.div
        className="portfolio-filter-bar"
        initial={{ y: -12, opacity: 0 }}
        whileInView={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.5, delay: 0.1 }}
        viewport={{ once: true }}
      >
        {["All", "Web App", "Mobile App"].map((menu) => (
          <motion.button
            key={menu}
            type="button"
            className={`portfolio-filter ${activeMenu === menu ? "active-filter" : ""}`}
            onClick={() => handleMenuClick(menu)}
            whileHover={{ scale: 1.04 }}
            whileTap={{ scale: 0.97 }}
          >
            {menu}
          </motion.button>
        ))}
      </motion.div>

      <motion.div
        className="portfolio-grid"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 0.8, delay: 0.2 }}
        viewport={{ once: true }}
      >
        <AnimatePresence mode="popLayout">
          {filteredProjects.map((project, index) => (
            <motion.div
              className="portfolio-item"
              key={project.key}
              initial={{ opacity: 0, y: 20, scale: 0.96 }}
              animate={{ opacity: 1, y: 0, scale: 1 }}
              exit={{ opacity: 0, y: 10, scale: 0.96 }}
              transition={{
                duration: 0.45,
                delay: index * 0.06,
                ease: "easeOut",
              }}
            >
              <PortfolioCard
                projectKey={project.key}
                title={project.title}
                image={project.image}
              />
            </motion.div>
          ))}
        </AnimatePresence>
      </motion.div>
    </motion.section>
  );
};
